export default __webpack_public_path__ + "static/media/trucking.ed2a359c.png";